import { useState } from 'react';
import { InfoWindow } from '@vis.gl/react-google-maps';
import { User } from 'src/api/wa/store/WaUserStore';
import { MapIconType } from '../pin/MapPin';
import mapIcon from '../icon/MapIcon';
import Button from '../../button/Button';
import { useTranslation } from 'react-i18next';
import { formatJpnDate } from 'src/common/formatJpnDate/formatJpnDate';
import useWaWorkplaceService from 'src/api/wa/service/WaWorkplaceService';
import { WaSalesOfficeOption } from 'src/api/wa/store/WaFilterStore';
import { useUserAgent } from 'src/common/userAgent/useUserAgent';

export interface UserMarkerProp {
  type: MapIconType;
  location: { latitude: number; longitude: number };
  user?: User & { displayIndex?: number };
  canOpenPopup: boolean;
  popupOpened?: () => void;
  popupClosed?: () => void;
  selectedWorkerId?: string | null;
  onWorkerSelected?: ((userId: string | null) => void) | undefined;
}

function LocationMarker({
  type,
  location,
  user,
  canOpenPopup,
  selectedWorkerId,
  onWorkerSelected,
  popupOpened,
  popupClosed,
}: UserMarkerProp) {
  const { t } = useTranslation();
  const [isInfoWindowOpen, setIsInfoWindowOpen] = useState(false);
  const [salesOffice, setSalesOffice] = useState<WaSalesOfficeOption | undefined>(undefined);
  const { fetchSalesOffice } = useWaWorkplaceService();
  const userAgent = useUserAgent();

  const handleSelected = () => {
    if (!user) return;

    if (selectedWorkerId === user.id) {
      onWorkerSelected?.(null);
    } else {
      onWorkerSelected?.(user.id);
      setIsInfoWindowOpen(false);
    }
  };

  if (!location || location.latitude == null || location.longitude == null) {
    return null;
  }

  const icon = mapIcon(type, user?.displayIndex);

  return (
    <>
      <div
        className="cursor-pointer"
        onClick={() => {
          if (canOpenPopup) {
            if (user?.branchCode) {
              fetchSalesOffice(user.branchCode, user.salesOfficeCode).then((office) => {
                setSalesOffice(office);
              });
            }

            setIsInfoWindowOpen(true);
            popupOpened?.();
          }
        }}
      >
        {icon}
      </div>

      {isInfoWindowOpen &&
        canOpenPopup &&
        (type === MapIconType.currentUserMatch ||
          type === MapIconType.currentUserNoMatch ||
          type === MapIconType.worker ||
          type === MapIconType.workerNoMatch) && (
          <InfoWindow
            position={{ lat: location.latitude, lng: location.longitude }}
            onCloseClick={() => {
              setIsInfoWindowOpen(false);
              popupClosed?.();
            }}
          >
            <div className="flex flex-col gap-2 p-1 text-sm text-black">
              <label className="m-0 text-center font-bold">{user?.name}</label>
              <label className="m-0 text-center font-medium">{user?.telephoneNumber}</label>
              <label className="m-0 text-center font-medium">
                <span className="pr-1">{salesOffice?.code}</span>
                <span>{salesOffice?.name}</span>
              </label>
              <label className="m-0 text-center font-medium">
                {user?.locationUpdateDate ? formatJpnDate({ iso: user.locationUpdateDate }) : '-'}
              </label>
              {userAgent.isDesktop && (
                <Button title={t('wards.common.select')} onClick={handleSelected} />
              )}
            </div>
          </InfoWindow>
        )}
    </>
  );
}
export default LocationMarker;
